import { FormControlLabel, Switch } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../../modules/localization/components/AppLocalized"
import { HIDDEN_IN_PRINT } from "../../print/printPageOnly"

const useStyles = makeStyles()((theme) => ({
    root: {
        marginLeft: 0,
        marginRight: 0,
        gap: ".5rem",
        "& .MuiFormControlLabel-label": {
            fontSize: theme.typography.body2.fontSize,
            fontWeight: 500,
            color: theme.palette.tailwind.slate[800],
        },
        ...HIDDEN_IN_PRINT,
        [theme.breakpoints.up("sm")]: {
            "& .MuiFormControlLabel-label": {
                whiteSpace: "nowrap",
            },
        },
    },
}))

type PrintChatHistoryToggleProps = Readonly<{
    isChecked: boolean
    onChange: (isChecked: boolean) => void
}>

export function PrintChatHistoryToggle({ isChecked, onChange }: PrintChatHistoryToggleProps) {
    const { classes } = useStyles()

    return (
        <LocalizedStrict id="order-chat-history-print-toggle" attrs={{ label: true }}>
            <FormControlLabel
                className={classes.root}
                label="Print chat history"
                labelPlacement="start"
                control={<Switch checked={isChecked} onChange={(event) => onChange(event.target.checked)} />}
            />
        </LocalizedStrict>
    )
}
